module.exports = __webpack_public_path__ + "static/media/question-icon.f2f789c3.svg";